import * as React from 'react';
import { SimpleForm, TextInput, Title } from 'react-admin';
import { Card, CardContent, TableCell, TableRow, TableHead, TableBody, Paper, Table, TableContainer } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

const initExpoCall = httpsCallable(functions, 'initExpoCall');
const listExpoCall = httpsCallable(functions, 'listExpoCall');

interface IInitExpo {
  expoName: string;
}

export const ExpoInit = () => {
  const [existingExpos, setExistingExpos] = React.useState<string[]>([]);

  React.useEffect(() => {
    const doit = async () => {
      const expos = await listExpoCall();
      setExistingExpos(expos.data as string[]);
    };
    doit();
  }, []);

  const initExpo = (args: any) => {
    initExpoCall((args as IInitExpo).expoName);
  };

  return (
    <Card>
      <Title title="Init Expo" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Expo Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {existingExpos.map((expoName: string) => (
                <TableRow key={expoName}>
                  <TableCell>
                    <a href={`https://${window.location.hostname}/${expoName}`}>{expoName}</a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>

      <CardContent>
        <SimpleForm onSubmit={initExpo}>
          <TextInput source="expoName" />
        </SimpleForm>
      </CardContent>
    </Card>
  );
};
